<template>
  <message-page-with-image class="server-error" title="What?" imgAlt="Jackie Chan confused" :imgSrc='jackieImg'>
    <template v-slot:append>
      <i18n path="http_errors.500.message" tag="span" class="text-h5">
        <template #contact>
          <a href="/contact">{{ $t('http_errors.500.contact') }}</a>
        </template>
      </i18n>
    </template>
  </message-page-with-image>
</template>

<script>
import { defineComponent } from 'vue'
import MessagePageWithImage from '../components/error/MessagePageWithImage'
import jackieImg from '../assets/jackie.png';

export default defineComponent({
  components:{
    MessagePageWithImage
  },
  setup(){
    return {
      jackieImg
    }
  }
})
</script>